import styled from '@emotion/styled'
import { COLORS } from 'global-styles'

export const InformationDialog = styled.div`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	top: 20px;
	width: 350px;
	background-color: white;

	.ccontainer {
		padding: 20px;
		border: 1px solid ${COLORS.rebrand_primary};

		h4 {
			text-align: center;
			color: ${COLORS.rebrand_primary};
		}

		p {
			margin: 0;
		}

		svg {
			margin-top: 1px;
		}

		.box {
			align-self: flex-start;
			border-radius: 8px;
			font-size: 0.8rem;
			text-wrap: nowrap;
			padding: 2px 6px;
			margin-right: 10px;

			&.call {
				color: white;
				margin-top: 2px;
				background-color: ${COLORS.prospectix_orange};
			}

			&.conditional {
				margin-top: 2px;
				color: white;
				background-color: ${COLORS.purple};
			}
		}
	}

	@media (min-width: 1500px) {
		width: 450px;
	}

	@media (min-width: 1700px) {
		width: 600px;
	}

	@media (min-width: 2000px) {
		width: 800px;
	}
`

export const Box = styled.div`
	width: 200px;
	color: white;
	text-align: center;
	border-radius: 5px;
`

export const HeaderBox = styled(Box)`
	width: 250px;
	height: 40px;
	line-height: 39px;
	font-size: 1.15rem;
	background-color: ${COLORS.primary};
	margin: 0px 125px;
	font-weight: bold;
`

export const ConditionalBox = styled(Box)`
	width: 250px;
	height: 40px;
	line-height: 39px;
	font-size: 1.15rem;
	background-color: ${COLORS.purple};
	color: ${COLORS.white};
	margin: 0px 125px;
	font-weight: bold;
`

export const Container = styled.div`
	position: relative;

	.event {
		padding: 10px 0;
		flex: 1;

		.v-lines {
			height: 50px;
			position: relative;
		}
	}

	.descriptions {
		width: 250px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		font-size: 0.85rem;
		padding-right: 15px;

		span {
			width: 100%;
			height: 100px;
			line-height: 100px;
			text-align: right;
		}
	}
`

export const EventContainer = styled.div`
	display: flex;
	align-items: center;
	position: relative;
	flex: 1;

	.multi-description-lines {
		& > div {
			display: flex;
			align-items: center;
			height: 100px;
			position: relative;

			&.top-line::before {
				content: '';
				position: absolute;
				right: 0;
				top: 0;
				width: 2px;
				height: 50%;
				background-color: ${COLORS.dark};
			}

			&.bottom-line::after {
				content: '';
				position: absolute;
				right: 0;
				bottom: 0;
				width: 2px;
				height: 50%;
				background-color: ${COLORS.dark};
			}
		}
	}

	&.top-line::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: 2px;
		height: 50%;
		background-color: ${COLORS.dark};
	}

	&.bottom-line::after {
		content: '';
		position: absolute;
		left: 0;
		bottom: 0;
		width: 2px;
		height: 50%;
		background-color: ${COLORS.dark};
	}
`

export const ActionContainer = styled.div`
	display: flex;
	align-items: center;
	position: relative;

	&.top-line::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: 2px;
		height: 50%;
		background-color: ${COLORS.dark};
	}

	&.bottom-line::after {
		content: '';
		position: absolute;
		left: 0;
		bottom: 0;
		width: 2px;
		height: 50%;
		background-color: ${COLORS.dark};
	}

	.react-toggle {
		transform: scale(0.7);
	}
`

export const ActionBox = styled(Box)`
	width: 250px;
	background-color: white;
	color: inherit;
	margin: 10px 0;
	border: 1px solid ${COLORS.black};
	padding: 5px 0 2px 0;

	hr {
		margin: 1px 10px;
	}

	hr.type-2 {
		margin: 3px 10px 2px 10px;
		border-color: ${COLORS.black};
	}

	.header {
		padding-bottom: 0;
		margin: 0;
		font-weight: bold;
		color: ${COLORS.black};
	}

	.selector {
		font-size: 0.95rem;
		padding-left: 10px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.settings {
			color: ${COLORS.warning};
			font-size: 1rem;
			cursor: pointer;
		}

		.information {
			color: ${COLORS.primary};
			font-size: 1.01rem;
			margin-left: 2px;
			cursor: pointer;
		}

		.locked {
			margin-left: 3.5px;
			color: ${COLORS.danger};
		}
	}
`

export const CallBox = styled(Box)`
	width: 250px;
	background-color: ${COLORS.prospectix_orange};
	margin: 10px 0;
	padding-top: 7px;
	padding-bottom: 5px;

	.header {
		padding-bottom: 0;
		margin: 0;
		font-weight: bold;
	}

	svg {
		margin-top: -1.5px;
		color: ${COLORS.white};
	}
`

export const HLineShort = styled.div`
	border-top: 1px solid ${COLORS.dark};
	border-bottom: 1px solid ${COLORS.dark};
	width: 20px;
	margin-right: 15px;
	position: relative;
`

export const HLineLong = styled(HLineShort)`
	width: 50px;
	margin-right: 0;
`

export const HLine2 = styled(HLineShort)`
	margin-left: 15px;
	flex: 2;
`

export const ActionSettings = styled.div`
	width: calc(100% - 50px);
	position: absolute;
	top: 10px;
	left: 50px;
	display: flex;

	.card-container {
		width: 90%;
		z-index: 100;

		.card {
			min-height: 40px;

			.header {
				width: 100%;
				height: 40px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0 10px;
			}
		}
	}
`

export const TemplateSelectorContainer = styled.div`
	background-color: white;
	border: 1px solid ${COLORS.black};
	border-radius: 8px;
	margin-bottom: 20px;

	hr {
		margin: 0 10px;
	}

	.header {
		background-color: ${COLORS.grey_3};
		border-radius: 8px;
	}

	.hint {
		font-style: oblique;
	}

	.template {
		&:hover {
			background-color: ${COLORS.lightGrey};
		}
	}

	.buttons {
		display: flex;
		align-items: center;

		.btn {
			text-wrap: nowrap;
			padding: 1px 5px;
		}
	}
`

export const ParentContainer = styled.div`
	margin-left: 0px;

	@media (min-width: 1400px) {
		margin-left: 10px;
	}

	@media (min-width: 1500px) {
		margin-left: 20px;
	}

	@media (min-width: 1700px) {
		margin-left: 30px;
	}

	@media (min-width: 2000px) {
		margin-left: 100px;
	}
`
